/**
 * @file ScreenCreate.js
 * @module ScreenCreate
 * @description ローディング画面・エラー画面など遷移用画面を生成するモジュール
 */
import { SC_STATE , C_URLS , C_LOGWORDING , C_ERRWORDING } from './Constants';
import { toast } from 'react-toastify';
//const ROOT_LOGIN_URL = process.env.REACT_APP_ROOT_LOGIN_URL;
const ROOT_LOGIN_URL = "https://web.console-solution-dev.alap-cloud.net/";

/**
 * ローディング・エラー・サービス停止時の画面を表示するコンポーネント
 * @component
 * @param {Object} props
 * @param {string} props.message - 表示するメッセージや状態
 * @param {Object} [props.error] - エラーオブジェクト（任意）
 * @returns {JSX.Element} ローディング・エラー画面
 */
const ScreenCreate = ({ message, error }) => {
  // error情報をまとめて取得
  const errorCode = error?.errorCode || '';
  const errorMessage = error?.errorMessage || '';
  const detailedMessage = error?.detailedMessage || '';

  if (error) {
    toast.error(`エラー\nErrCode:${errorCode}\nErrlog:${errorMessage}\n詳細: ${detailedMessage}`);
  }

  let content;

  switch (message) {
    case SC_STATE.BI_TOKEN_FETCHING:
    case SC_STATE.BI_TOKEN_REFETCHING:
      content = (
        <div>
          <h2>ユーザ情報とコンテンツを更新しています。<br />しばらくお待ちください。</h2>
        </div>
      );
      break;
    case SC_STATE.ERR_PERMANENT:
      content = (
        <div>
          <h2>画面表示中にエラーが発生しました<br />管理者へお問い合わせください。</h2>
          <p>エラー内容：{errorCode} : {errorMessage}</p>
          <p>
            <a href={C_URLS.ROOT_LOGIN} target="_parent" rel="noopener noreferrer">
              こちらをクリックしてリロード
            </a>
          </p>
        </div>
      );
      break;
    case SC_STATE.ERR_NONPERMANENT:
      content = (
        <div>
          <h2>画面表示中にエラーが発生しました<br />リロードしてください</h2>
          <p>エラー内容：{errorCode} : {errorMessage}</p>
          <p>
            <a href={C_URLS.ROOT_LOGIN} target="_parent" rel="noopener noreferrer">
              こちらをクリックしてリロード
            </a>
          </p>
        </div>
      );
      break;
    case SC_STATE.BI_ERR_PERMANENT:
      content = (
        <div>
          <h2>Power BI の表示中にエラーが発生しました<br />管理者へお問い合わせください。</h2>
          <p>エラー内容：{errorCode} : {errorMessage}</p>
          <p>
            <a href={C_URLS.ROOT_LOGIN} target="_parent" rel="noopener noreferrer">
              こちらをクリックしてリロード
            </a>
          </p>
        </div>
      );
      break;
    case SC_STATE.BI_ERR_NONPERMANENT:
      content = (
        <div>
          <h2>Power BI の表示中にエラーが発生しました<br />リロードしてください</h2>
          <p>エラー内容：{errorCode} : {errorMessage}</p>
          <p>
            <a href={C_URLS.ROOT_LOGIN} target="_parent" rel="noopener noreferrer">
              こちらをクリックしてリロード
            </a>
          </p>
        </div>
      );
      break;
    default:
      content = (
        <div>
          <h2>エラーです<br />リロードしてください</h2>
          <p>エラー内容：{errorCode} : {errorMessage}</p>
          <p>
            <a href={C_URLS.ROOT_LOGIN} target="_parent" rel="noopener noreferrer">
              こちらをクリックしてリロード
            </a>
          </p>
        </div>
      );
      break;
  }

  return (
    <div style={{
      background: 'rgba(0,0,0,0.5)',
      width: '100vw',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <div style={{
        background: 'white',
        padding: '20px',
        borderRadius: '10px',
        textAlign: 'center'
      }}>
        {content}
      </div>
    </div>
  );
};

export default ScreenCreate;